import { REACT_APP_BRIDGE_RETURN_HOSTS } from '../config/constants';

export const BRIDGE_RETURN_URL_PATH_PREFIX = '/analises';

const MAX_RETURN_URL_LENGTH = 2048;

const DEFAULT_PROD_HOSTS = ['salespetro.com.br', 'www.salespetro.com.br'] as const;

const DEV_LOCAL_HOSTS = ['localhost', '127.0.0.1'] as const;

const parseEnvHosts = (raw: string | undefined): string[] => {
  if (!raw?.trim()) return [];
  return raw
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
};

/** Allowlist de hostnames autorizados para return_url do Bridge Code. */
export const getBridgeReturnUrlAllowedHosts = (
  nodeEnv: string | undefined = process.env.NODE_ENV,
  envHostsRaw: string | undefined = REACT_APP_BRIDGE_RETURN_HOSTS
): string[] => {
  const hosts = new Set<string>([...DEFAULT_PROD_HOSTS, ...parseEnvHosts(envHostsRaw)]);

  if (nodeEnv === 'development') {
    DEV_LOCAL_HOSTS.forEach((host) => hosts.add(host));
  }

  return Array.from(hosts);
};

const isLocalDevHost = (hostname: string): boolean =>
  DEV_LOCAL_HOSTS.includes(hostname.toLowerCase() as (typeof DEV_LOCAL_HOSTS)[number]);

export interface SanitizeReturnUrlOptions {
  nodeEnv?: string;
  envHosts?: string;
}

/**
 * Valida e sanitiza `return_url` contra open redirect.
 * Retorna a URL canônica ou `null` (descarte silencioso).
 */
export const sanitizeReturnUrl = (
  raw: string | null | undefined,
  options?: SanitizeReturnUrlOptions
): string | null => {
  if (raw == null) return null;

  const trimmed = raw.trim();
  if (!trimmed || trimmed.length > MAX_RETURN_URL_LENGTH) return null;

  if (trimmed.startsWith('//')) return null;

  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return null;
  }

  if (url.username || url.password) return null;

  const nodeEnv = options?.nodeEnv ?? process.env.NODE_ENV;
  const hostname = url.hostname.toLowerCase();
  const allowedHosts = getBridgeReturnUrlAllowedHosts(nodeEnv, options?.envHosts);
  if (!allowedHosts.includes(hostname)) return null;

  const isDev = nodeEnv === 'development';
  if (url.protocol === 'https:') {
    // ok
  } else if (url.protocol === 'http:' && isDev && isLocalDevHost(hostname)) {
    // ok — http apenas em localhost/127.0.0.1 no development
  } else {
    return null;
  }

  if (!url.pathname.startsWith(BRIDGE_RETURN_URL_PATH_PREFIX)) return null;

  return url.href;
};
